import { createContext } from "react";

const StoreContext = createContext();
StoreContext.displayName = "Store";

export default StoreContext;
